<!-- eslint-disable tailwindcss/no-custom-classname -->
<section>
  <div>
    @if (!hideIsCompletedStatus()) {
      <sb-icon
        [ngClass]="{
          'text-brand': item().isCompleted,
          'text-subtle': !item().isCompleted,
        }"
        [name]="item().isCompleted ? 'check-circle-solid' : 'circle'"
      />
    }

    <p>
      @if (listIndex() !== undefined) {
        <span>{{ listIndex()! + 1 }}.</span>
      }
      {{ item().title }}
    </p>
  </div>

  <article class="accordion-animation-wrapper">
    <div class="accordion-animation">
      <div class="accordion-transform-wrapper">
        <div class="accordion-transform-content">
          @if (item().subtitle) {
            <p>{{ item().subtitle }}</p>
          }
          @if (item().actions) {
            @let actions = item().actions!;
            <div>
              @if (actions.primary) {
                <button [size]="'sm'" sb-button [color]="'primaryAlt'" (click)="onClick(actions.primary!.action)">
                  {{ actions.primary!.text }}
                </button>
              }
              @if (actions.secondary) {
                <button
                  sb-button
                  [size]="'sm'"
                  [color]="actions.secondary!.palette || 'secondary'"
                  (click)="onClick(actions.secondary!.action)"
                >
                  {{ actions.secondary!.text }}
                </button>
              }
              @if (item().trialExtension) {
                <span
                  class="text-sm font-semibold"
                  [ngClass]="{
                    'text-success-strong': !item().trialExtensionUsed,
                    'text-subtle line-through': item().trialExtensionUsed,
                  }"
                  [sbTooltip]="trialExtensionTooltip"
                  [sbTooltipPlacement]="'top'"
                >
                  {{ trialExtensionLabel }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </article>
</section>
